/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyFromJSON, StreemApiCompanyToJSON, } from './';
export function StreemApiSearchCompaniesForUserEmailResponseFromJSON(json) {
    return StreemApiSearchCompaniesForUserEmailResponseFromJSONTyped(json, false);
}
export function StreemApiSearchCompaniesForUserEmailResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companies': !exists(json, 'companies') ? undefined : (json['companies'].map(StreemApiCompanyFromJSON)),
    };
}
export function StreemApiSearchCompaniesForUserEmailResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'companies': value.companies === undefined ? undefined : (value.companies.map(StreemApiCompanyToJSON)),
    };
}
//# sourceMappingURL=StreemApiSearchCompaniesForUserEmailResponse.js.map